export const GLOBAL_ROUTE_CONSTANTS = {
	EMPTY: '/',
	CABINET: '/cabinet',
	COURSES: '/courses',
	DASHBOARD: '/dashboard'
};